export default __webpack_public_path__ + "static/cmp-44e376d20de166a670467e1424936be6.png";